<template>
  <div class="category-container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="数据分类" name="dataCategory">
        <div class="dataCategory-list">
          <div v-for="index in dataCategory" :key="index"></div>
          <router-link
            class="dataCategory-item"
            v-for="(item, index) in dataCategory"
            :key="index"
            :to="'/data_public/index?dataCategoryId=' + item.id"
          >
            <img :src="item.icon" alt="" srcset="" />
            {{ item.name }}
          </router-link>
        </div>
      </el-tab-pane>
      <el-tab-pane label="机构分类" name="departmentCategroy"
        ><div class="category-list">
          <router-link
            class="category-item"
            v-for="(item, index) in departmentCategroy"
            :key="index"
            :to="'/data_public/index?departmentCategroyId=' + item.id"
          >
            <el-popover trigger="hover" placement="bottom" :width="260">
              <div
                style="text-align:center;font-size: 14px;
font-weight: 400;
color: #333333;
line-height: 20px;"
              >
                数据集 ({{ item.datasetCount ? item.datasetCount : 0 }}) | 接口
                ({{ item.ifaceCount ? item.ifaceCount : 0 }}）
              </div>

              <template #reference>
                <text>{{ item.name }}</text>
              </template>
            </el-popover>
          </router-link>
        </div></el-tab-pane
      >
    </el-tabs>
  </div>
</template>

<script>
import { getAppMarkHot, getOrg } from "@/api/index";

export default {
  data() {
    return {
      acticveNavIndex: 0,
      activeName: "dataCategory",
      dataCategory: [],
      departmentCategroy: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      var { result } = await getAppMarkHot();
      this.dataCategory = result;
      var data = await getOrg({ dataType: "PROVINCIAL" });
      this.departmentCategroy = data.result;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style lang="scss" scoped>
.category-container {
  margin: 0 auto;
  padding: 50px 0;
  width: 1206px;

  .dataCategory-list {
    margin-top: 30px;
    float: left;
    display: flex;
    flex-wrap: wrap;
    .dataCategory-item:hover {
      color: #2a7ee3 !important;
    }
    .dataCategory-item {
      margin-top: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 150px;
      height: 120px;
      font-size: 24px;
      font-weight: 400;
      color: #444444;
      img {
        width: 66px;
        height: 66px;
        margin-bottom: 20px;
        border-radius: 50%;
      }

      .dataCategory-item + .dataCategory-item {
        margin-left: 20px;
      }
    }
  }

  .category-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    float: left;
    .category-item + .category-item {
      margin-right: 20px;
    }
    .category-item:first-child {
      margin-right: 20px;
    }
    .category-item {
      display: flex;

      justify-content: center;
      align-items: center;
      width: 220px;
      font-size: 16px;
      font-weight: 400;
      color: #444444;
      height: 60px;
      background: #eeeeee;
      border-radius: 4px;
      margin-top: 13px;
    }
    .category-item:hover {
      background: #2a7ee3;
      border-radius: 4px;
      color: #ffffff;
    }
  }
}
</style>
